 
<template>
    
     
    <div id="NavigatorChartData">

<nav class="navbar is-primary">
  <div class="navbar-brand">
       
  
          
      

     <p class="navtitle">{{title}}</p>
     </div>
    

        <div class="navbar-menu is-active" >
        <div class="navbar-start">
           
        </div>
        <div class="navbar-end">
             <div class="navbar-item">
        <div class="field is-grouped">
   <p class="control">
   <b-button
                type="is-primary"
                icon-pack="fas"
                icon-left="window-maximize"
                title="Maximised Single Column"
                @click="listChartsMaximised()" />
    </p>
   <p class="control">
   <b-button
                type="is-primary"
                icon-pack="fas"
                icon-left="align-justify"
                title="Single Column"
                @click="listCharts()" />
    </p>
     <p class="control">

                      <b-button
                type="is-primary"
                icon-pack="fas"
                icon-left="th-large"
                title="2 Columns"
                @click="columnise2Charts()" />
             
             
  </p>
       <p class="control">
         
                      <b-button
                type="is-primary"
                icon-pack="fas"
                icon-left="th" 
                title="3 Columns"
                 @click="columnise3Charts()"/>
        
  </p>
     </div>
        </div>
    
            <img  class="navlogo" src="@/assets/sie-logo-claim-white-rgb.png"/>
        </div>
    </div>
     </nav>

  

             <div class="loading" v-if="loading">
        <b-loading :is-full-page="isFullPage" :active.sync="loading" :can-cancel="true"></b-loading>
        </div>


           <section class="section" v-if="!loading">

                {{message}}
                  
                        <!-- charts -->
                        <!--
                        <div v-for="chart in charts">
                            <ReactiveChart @relayout_zoom="relayout_graphs" :chart="chart"></ReactiveChart>
                        </div>
                        -->
                        <div  v-if="renderComponent">
                         <div v-if="columns_to_display==1 && rows_to_display==1">
                            <div v-for="chart in columns[0]">
                                <ReactiveChart @relayout_zoom="relayout_graphs" :chart="chart"></ReactiveChart>
                            </div>
                        </div>


                        <div v-if="columns_to_display==1 && rows_to_display==2">
                            <div v-for="chart in columns[0]">
                                <ReactiveChart @relayout_zoom="relayout_graphs" :chart="chart"></ReactiveChart>
                            </div>
                        </div>

                     
                         <div v-if="columns_to_display==2">
                           <div class="columns">
                                <div class="column">
                                     <div v-for="chart in columns[0]">
                                <ReactiveChart @relayout_zoom="relayout_graphs" :chart="chart"></ReactiveChart>
                                    </div>
                                </div>
                                
                                <div class="column">
                                     <div v-for="chart in columns[1]">
                                <ReactiveChart @relayout_zoom="relayout_graphs" :chart="chart"></ReactiveChart>
                                </div>
                                </div>
                            </div>
                        </div>


                         <div v-if="columns_to_display==3">
                           <div class="columns">

                                <div class="column">
                                     <div v-for="chart in columns[0]">
                                <ReactiveChart @relayout_zoom="relayout_graphs" :chart="chart"></ReactiveChart>
                                    </div>
                                </div>

                                <div class="column">
                                     <div v-for="chart in columns[1]">
                                <ReactiveChart @relayout_zoom="relayout_graphs" :chart="chart"></ReactiveChart>
                             </div>
                               </div>

                                <div class="column">
                               <div v-for="chart in columns[2]">
                                <ReactiveChart @relayout_zoom="relayout_graphs" :chart="chart"></ReactiveChart>
                             </div>
                                </div>

                            </div>
                        </div>
                        </div>
                     
                  

        </section>


  <b-modal v-model="passwordModalActive" :active.sync="passwordModalActive" :can-cancel="canCancelModal" :autofocus="true">
                <div class="modal-card">

                    <section class="modal-card-body">
                        <b-field label="Password">
                            <b-input type="password"
                            id="password_input"
                            v-on:keyup.enter.native="submitPassword"
                            v-model="password"
                                password-reveal>
                            </b-input>
                        </b-field>
                 
                        </section>
                    
                        <b-button
                            label="Submit"
                            type="is-primary"
							@click="submitPassword"/>
               
         
                 
                </div>

        </b-modal>
        <!-- end of app -->
    </div>
</template>

<script>

import LoadingComponent from '@/components/LoadingComponent';
import ReactiveChart from '@/components/ReactiveChartwithNonReloadingBubbleChart';
import moment from 'moment';
import PasswordModalComponent from  '@/components/PasswordModalComponent.vue'
//VUE ROOT remove password when ready
export default {
	name: 'navigatorChartsDataDashboard',
    components: {LoadingComponent, ReactiveChart,PasswordModalComponent},
        // Empty data array to initialise axios data into
        data: function() { return { 
            proxyurl: this.$store.getters.proxyurl,
            apiurl: this.$store.getters.apiurl,
        	loading: true,
        	charts: [],
            legendFontSize: 18,
            legendYPos: 1.3,
            includeRangeSlider: false,
            autoGraphData: true,
            graphType: "Units",
            graphsHaveDataFlag: false,
            isCreatePublicLinkModalActive:false,
            password_required:false,
            password:'',
            isFullPage:true,
            title:'',
            passwordModalActive:false,
            message:'',
            canCancelModal:[],
            columns_to_display:1,
            rows_to_display:2,
            displayCharts:true,
            renderComponent:true
            
        }
    },

                computed: {
                columns () {

                let columns = []
                let mid = Math.ceil(this.charts.length / this.columns_to_display)
                for (let col = 0; col < this.columns_to_display; col++) {
                    let chartData = this.charts.slice(col * mid, col * mid + mid)

                    //set height
                    chartData.forEach((chart)=>{
                        let chart_height_calculation = (window.innerHeight-52)/this.rows_to_display
                        chart.layout.height = chart_height_calculation


                    //set margins
                    if(this.columns_to_display == 1){
                        if (this.rows_to_display == 1){
                            chart.layout.margin= {l: 100, r: 100,b: 100,t: Math.min(chart_height_calculation*0.15,250),pad: 0}
                        }else{
                        chart.layout.margin= {l: 100, r: 100,b: 100,t: chart_height_calculation*0.2,pad: 0}
                        }
                    }
                    if(this.columns_to_display == 2){
                        chart.layout.margin= {l: 50, r: 50,b: 70,t: chart_height_calculation*0.2,pad: 0}
                    }
                    if(this.columns_to_display == 3){
                        chart.layout.margin= {l: 40, r: 40,b: 70,t: chart_height_calculation*0.2,pad: 0}
                    }
                    })

                    columns.push(chartData)
                }
                this.forceRerenderCharts() //rerender to reduce any DOM issues when going from 3 columns to fewer columns
                return columns
                }
            },
 

        methods: {         	
         listChartsMaximised(){
                this.rows_to_display=1;
                this.columns_to_display=1;

        },
            
    //Function to make charts into 1 columns (list)
        listCharts() {
            this.columns_to_display=1;
            this.rows_to_display=2;
        },

    //Function to make charts into 2 columns
      columnise2Charts() {
          this.columns_to_display=2;
          this.rows_to_display=2;
        },

    //Function to make charts into 3 columns
         columnise3Charts() {
              this.columns_to_display=3;
              this.rows_to_display=2;
         },

        async get_graph_data_for_link(password){
             this.loading=true;
             const url = this.apiurl + "get_graph_data_for_link"
             
             //return for the async await
            await this.$axios({
                    method: 'POST',
                    url: url,
                    data: {
                        'password': this.password,
                        'uuid': this.$route.params.uuid
                    },
                    headers: {
                        'content-type': 'application/json',
                    }
                })
                .then((response) => {

                // if there is only one chart, then make rows to display = 1
                 if (response.data.charts_data.length == 1){
                    this.rows_to_display =1
                    this.columns_to_display =1
                }   

                    //check charts to format any data for display purposes
                response.data.charts_data.forEach((chart)=>{
                    
                    //for old charts where datetime is not explicity formated, convert to local.
                    //for new charts (version 2), then do nothing
                    if (chart.chartVersion != 2){
                    chart.traces.forEach((trace)=>{
                        for (let i = 0; i < trace.x.length; i++)
                        {
                        let utcDateTime = trace.x[i]
                        trace.x[i] = moment.utc(utcDateTime).local().toDate()
                        }
                      })
                    }

                })

                this.charts = response.data.charts_data
                    this.message=response.data.message
                this.title = response.data.title;
                this.passwordModalActive=false
                 this.loading=false;
             
                 
               }).catch(error => {
                        console.log(error)
                        this.loading=false;

                }); 
        },

        async validate_graph_data_link(){
             this.loading=true;
             const url = this.apiurl + "validate_graph_data_link?uuid="+this.$route.params.uuid
             
             //return for the async await
               await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',},
            }).then(response => {
                
                this.message = response.data.message
                this.password_required = response.data.password_enabled;
                 this.loading=false;
                 
               }).catch(error => {
                        console.log(error)
                        this.loading=false;

                }); 

                return
        
        },
        
        //initial load method, with async methods so each function waits for the previous one to finish
        async initialLoad() {
            await this.validate_graph_data_link()

            if (this.password_required == false){
                this.get_graph_data_for_link(this.password)
         
            }
            else{
                this.passwordModalActive = true
            }

        },
        

        //if there is an event for a graph to update its range, will update all graphs ranges. 
        relayout_graphs(payload){
            //console.log("changing layout ranges")
            //console.log(payload)
            this.charts.forEach(chart => {
                if ( "xaxis.autorange" in payload) {
                   
                    chart.layout.xaxis.autorange = true
                }
                else if ("xaxis.range[0]" in payload){
                      chart.layout.xaxis.autorange = false
                       chart.layout.xaxis.range = [payload["xaxis.range[0]"],payload["xaxis.range[1]"]]
                }

                     if ( "yaxis.autorange" in payload) {
                   
                    chart.layout.yaxis.autorange = true
                }
                else if ("yaxis.range[0]" in payload){
                      chart.layout.xaxis.autorange = false
                     chart.layout.yaxis.range = [payload["yaxis.range[0]"],payload["yaxis.range[1]"]]
                }
            
                //console.log(chart.layout)
            });

        },
        submitPassword(){
            this.get_graph_data_for_link(this.password)
        },

        forceRerenderCharts() {
                // Remove my-component from the DOM
                this.renderComponent = false;

                this.$nextTick(() => {
                // Add the component back in
                this.renderComponent = true;
                });
            }
        },
    
        //Mounted Stage
        mounted() {
   this.initialLoad();   
    },

   watch: {
    columns: function (val) {
        //force resize event to update repsonsizeness of charts when new data is loaded
   window.dispatchEvent(new Event('resize'));
    },
   }
 

      };
      
      
     

     
  </script>
  
  
  <style scoped>


.navbar-item {
  display: flex;
    color: white;
}

.navbar,
.navbar-menu,
.navbar-start,
.navbar-end {
  align-items: stretch;
  display: flex;
  padding: 0;
  
}

.navbar-menu{
  flex-grow: 1;
  flex-shrink: 0;
    background-image: linear-gradient(to right,#009999, #000028, #000028);
    color: white;
  
}
.navbar-start{
  justify-content: flex-start;
  margin-right: auto;
  
}
.navbar-end{
  justify-content: flex-end;
  margin-left: auto;
}

.modal-card, .modal-content {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: auto;
}
  
.hero-body, .section {
    padding-top: 0.1rem;
}

  .navbar.is-primary {
    background-image: linear-gradient(to right,#009999, #000028, #000028);
    color: white;
}

     .navbar{
        height:0.1em;
        }
       .navtitle {
            position: absolute;
            font-size:2em;
            width: 100%;
            left: 0;
            text-align: left;
            margin: auto;
            margin-top: 0em;
            padding-left: 0.5em;
        }
            
        
        .loading {
            position: absolute;
            font-size:1em;
            width: 100%;
            size: 10%;
         
            left: 0;
            text-align: center;
            margin: auto;
            margin-top: -0.2em;
        }
  
      .column.scroll {
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: wrap;
  
      
      }
      
      .level-item {
        flex-shrink: 1;
        padding-right: 10px;
        }
        
      .field.extra-space {
        padding-right: 30px;
        }
        
      .search-result-item {
        font-size:0.8em;
        }

       .navbar-text {
            position: absolute;
            font-size:2em;
            width: 100%;
            left: 0;
            text-align: left;
            margin: auto;
            margin-top: -0.4em;
            padding-left: 1em;
        }
        
        .loading {
            position: absolute;
            font-size:1em;
            width: 100%;
            size: 10%;
           padding-top: 4px;
            left: 0;
            text-align: center;
            margin: auto;
        }
       
               
        label.stack{  
            width:200px;       

            display:inline-block;    
            vertical-align:middle; 
        }

    .button.is-primary {
       background-color:#000028;
        color:white;
        }       
       
       .button.is-primary:hover{
         background-color:#000028;
           color:white;
       }
       

       .button.is-primary:active{
         background-color:#002949;
           color:white;
       }
             
        input:focus{
       outline-color: #002949;
       border-color: #000028;
       shadow-color: #000028;
      box-shadow: 0 0 3px #000028;
       }

       select:focus {
       outline-color: #002949 !important;;
       border-color: #000028 !important;;
       shadow-color: #000028;
      box-shadow: 0 0 3px #000028 !important;;
      }
       
             
  </style>